function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CPSpreadsheetProcessorCtrl = function CPSpreadsheetProcessorCtrl(StateUtils) {
    _classCallCheck(this, CPSpreadsheetProcessorCtrl);

    this.model = StateUtils.activeDataForState(true).model;
    this.hasBuildings = this.model.lobData.commercialProperty.coverables.locations.value.some(function (loc) {
        return loc.buildings && loc.buildings.length > 0;
    });
};

CPSpreadsheetProcessorCtrl.$inject = ['StateUtils'];

export default CPSpreadsheetProcessorCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/CPSpreadsheetProcessor/CPSpreadsheetProcessorCtrl.js
// module id = 1821
// module chunks = 0